import { render, staticRenderFns } from "./ResultSubmission.vue?vue&type=template&id=6310194a&scoped=true"
import script from "./ResultSubmission.vue?vue&type=script&lang=js"
export * from "./ResultSubmission.vue?vue&type=script&lang=js"
import style0 from "./ResultSubmission.vue?vue&type=style&index=0&id=6310194a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310194a",
  null
  
)

export default component.exports